import { createContext, ReactNode, useMemo } from 'react'

import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { SanitySiteStrings } from '@data/sanity/queries/types/strings'

interface StringsContextProviderProps {
  site: SanitySiteFragment
  children: ReactNode
}

const emptySiteStrings: SanitySiteStrings = {
  loadingPageTitle: '',
  languageSwitch: '',
  cartLink: '',
  featuredProducts: '',
  skipToContent: '',
  goHomeLabel: '',
  mobileMenuLabel: '',
  headerShopMenuShopLabel: '',
  headerShopMenuLogoutLabel: '',
  headerShopMenuNoShopLabel: '',
  headerShopSelectorPlaceholder: '',
  mobileMenuShopSelectorPlaceholder: '',
  mobileMenuShopSelectorLabel: '',
  productLowStock: '',
  productOutOfStock: '',
  productPriceLabel: '',
  productPriceFromLabel: '',
  productColorOptionLabel: '',
  productDiscountText: '',
  productIncreaseQuantity: '',
  productDecreaseQuantity: '',
  productEnterQuantity: '',
  productShopSelectorPlaceholder: '',
  productShopSelectorLabel: '',
  productOptionChooseColorMessage: '',
  productOptionChooseSizeMessage: '',
  cartTitle: '',
  cartClose: '',
  cartEmpty: '',
  cartVatSectionTitle: '',
  cartVatIdInputPlaceholder: '',
  cartVatIdError: '',
  cartInvalidVatIdError: '',
  cartCommentSectionTitle: '',
  cartCommentInputPlaceholder: '',
  cartDiscount: '',
  cartSubtotal: '',
  cartTotal: '',
  cartSubmit: '',
  cartSchoolInputLabel: '',
  cartSchoolInputPlaceholder: '',
  cartSchoolIdError: '',
  cartAddToCartErrorMessage: [],
  cartCommentLabel: '',
  cartSchoolLabel: '',
  cartShopIdAttributeName: '',
  cartProductNameAttributeName: '',
  cartFreetextAttributeName: '',
  cartFreetextColorAttributeName: '',
  cartAssetFilenameAttributeName: '',
  cartAssetColorAttributeName: '',
  cartAssetTitleAttributeName: '',
  carouselCounterText: '',
  carouselLeftArrowLabel: '',
  carouselRightArrowLabel: '',
  carouselDotLabel: '',
  buttonAddToCart: '',
  buttonAddToCartPrintProduct: '',
  buttonCreateShop: '',
  buttonRemove: '',
  buttonAccept: '',
  buttonLearnMore: '',
  buttonTryAgain: '',
  buttonLoadMore: '',
  buttonUnavailable: '',
  buttonWaiting: '',
  buttonLoading: '',
  buttonAdding: '',
  buttonUpdating: '',
  buttonSubmitting: '',
  buttonEdit: '',
  buttonDelete: '',
  buttonCancel: '',
  buttonGoBack: '',
  buttonNext: '',
  emailAddress: '',
  emailMissing: '',
  emailInvalid: '',
  productWaitlistSubmit: '',
  productWaitlistSuccess: '',
  productWaitlistError: '',
  yes: '',
  no: '',
  colorDark: '',
  colorLight: '',
}

export const StringsContext = createContext<SanitySiteStrings>(emptySiteStrings)

export const StringsContextProvider = ({
  site,
  children,
}: StringsContextProviderProps) => {
  const strings = useMemo(
    () => ({
      ...emptySiteStrings,
      ...site.siteStrings,
    }),
    [site.siteStrings],
  )

  return (
    <StringsContext.Provider value={strings}>
      {children}
    </StringsContext.Provider>
  )
}
